import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'semantic-ui-react';
import { useTranslate } from 'react-admin';

import { search } from '../../../../services/api';

import 'semantic-ui-css/components/search.css';
import 'semantic-ui-css/components/icon.css';
import 'semantic-ui-css/components/input.css';


const styles = {
	flex: 1,
	marginLeft: '25px'
};

const SearchBar = ({ staticContext, ...props }) => {
	const [value, setValue] = useState('');
	const [results, setResults] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const translate = useTranslate();

	const fetchData = async () => {
		setIsLoading(true);
		const data = await search(value);
		setIsLoading(false);
		setResults(data);
	};

	const handleResultSelect = (e, { result }) => {
		navigate(result.url);
		setValue('');
		setResults([]);
	};

	const handleSearchChange = async (e, { value }) => {
		setValue(value);
		setResults([]);
	};

	useEffect(() => {
		if (value.length === 0) {
			fetchData();
		}

		const timerId = setTimeout(() => {
			if (value.length >= 3) {
				fetchData();
			}
		}, 1000);

		return () => {
			clearTimeout(timerId);
		};
	}, [value]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Search
			category
			minCharacters={2}
			loading={isLoading}
			onResultSelect={handleResultSelect}
			onSearchChange={handleSearchChange}
			results={results}
			value={value}
			placeholder={translate("Search") + "..."}
			style={styles}
			{...props}
		/>
	);
};

export default SearchBar;
